import { useContext, useEffect, useMemo, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_ALL_PRESTACIONES } from "../../Querys/prestaciones/querys";
import Box from '@mui/material/Box';
import { Grid } from '@material-ui/core';
import TablePrestacion from "./TablePrestacion";
import { Benefit } from '../../interfaces/Benefit.interface';
import { PrestacionInfoCard } from "./PrestacionInfoCard";
import SearcherTablePrestacion from "./SearcherTablePrestacion";
import FiltrarIcon from "../../assets/svg/Filtrar.svg";
import Loading from "../Loading";
import { stopGlobalLoading } from "../../context/PrestacionesContext/Actions";
import PrestacionContext from '../../context/PrestacionesContext/PrestacionContext';

const BodyPrestacion = ({ viewSquare, viewList, infoImg }: any) => {
	const [filteredBenefits, setfilteredBenefits] = useState<Benefit[]>([]);
	const [initialBenefits, setInitialBenefits] = useState<Benefit[]>([]);
	const { dispatch } = useContext(PrestacionContext);
	const { data: prestacionesInfo, loading, refetch } = useQuery(GET_ALL_PRESTACIONES);

	const allBenefits = useMemo(() => {
		return prestacionesInfo?.GET_ALL_PRESTACIONES || [];
	}, [prestacionesInfo]);

	useEffect(() => {
		if (!loading && prestacionesInfo) {
			stopGlobalLoading(dispatch);
		}

		let listToProcess = [...allBenefits];
		if (Object.keys(infoImg).length > 0) {
			const img = infoImg as { idPrestacion: number, URL: string };
			listToProcess = listToProcess.map(prestacion => {
				if (prestacion.id == img.idPrestacion) {
					return { ...prestacion, URL: img.URL };
				}
				return prestacion;
			});
		}
		listToProcess.sort((a: any, b: any) => a.Titulo.localeCompare(b.Titulo));
		setfilteredBenefits(listToProcess);
		setInitialBenefits(listToProcess);
	}, [allBenefits, infoImg, loading, dispatch]);

	const filtrar = () => {
		const listToFilter = [...filteredBenefits];
		const nuevoFiltrado = listToFilter.sort((x: any, y: any) => x.Titulo.localeCompare(y.Titulo));
		setfilteredBenefits(nuevoFiltrado);
	};
	if (loading) {
		return <Loading />;
	}
	const hasBenefits = filteredBenefits?.length >= 1;
	return (
		<>
			<Box p={2} >
				<div className="containerBtnFindFilter">
					<div>
						<SearcherTablePrestacion
							initState={initialBenefits}
							setState={setfilteredBenefits}
							stateInitial={initialBenefits}
							label={"Buscar por prestación"}
							fields={['titulo']}
							width={400}
						/>
					</div>
					<div className="">
						<button
							id="addPrestacion"
							onClick={() => filtrar()}
							className="btnFiltrar"
						>
							<div className="alineacionBoton">
								<img src={FiltrarIcon} alt="filtrar" />
								<div className="nombrePrestacion">
									<b>
										<span>Filtrar</span>
									</b>
								</div>
							</div>
						</button>
					</div>
				</div>

				{hasBenefits ? (
					viewSquare ? (
						<Grid className="infoPrestacion">
							<Grid className="exCont">
								{filteredBenefits.map((prestacion: any) => (
									<PrestacionInfoCard
										key={prestacion.id}
										prestacion={prestacion}
									/>
								))}
							</Grid>
						</Grid>
					) : viewList ? (
						<Grid >
							<TablePrestacion
								prestaciones={filteredBenefits}
							/>
						</Grid >
					) : null
				) : (
					<Grid container justify="flex-start" >
						<span>Aún no tienes prestaciones registradas </span>
					</Grid>
				)}
			</Box>
		</>
	);
}

export default BodyPrestacion;